import React from 'react'
import ThoughtBox from '../components/thought-box'
import CTA from '../components/cta'

const ThoughtsPage = ({ data }) => (
  <section>
    <h3>Thoughts</h3>
    <section id='thoughts' className='container'>
      {data.allThoughtsYaml.edges.map(({ node }, index) =>
        <ThoughtBox
          key={node.title}
          title={node.title}
          blurb={node.blurb}
          link={node.link}
          year={node.year}
          month={node.month}
          minutes={node.minutes}
          publicationName={node.publicationName}
        />
      )}
    </section>

    <CTA primary={{to: '/inspiration', text: 'View Inspiration'}} scrollToTop={true} />
  </section>
)

export default ThoughtsPage

export const query = graphql`
query ThoughtsQuery {
  allThoughtsYaml {
    edges {
      node {
        title
        link
        blurb
        publicationName
        year
        month
        minutes
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/thoughts.js